<template>
  <div class="empty-state-view" :class="{ 'empty-state-view--compact': compact }" role="status" aria-live="polite">
    <div v-if="icon" class="empty-state-view__icon">
      <i :class="icon"></i>
    </div>
    <div class="empty-state-view__title">{{ displayTitle }}</div>
    <div v-if="hint" class="empty-state-view__hint">{{ hint }}</div>
  </div>
</template>

<script>
export default {
  name: "EmptyState",
  props: {
    title: {
      type: String,
      default: ''
    },
    tip: {
      type: String,
      default: ''
    },
    hint: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'el-icon-document'
    },
    compact: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayTitle() {
      return this.title || this.tip || '没有数据';
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-state-view {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 24px 20px;
  box-sizing: border-box;
  text-align: center;
  color: var(--im-session-text-muted);

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex: 0 0 40px;
    border-radius: 10px;
    background: rgba(var(--im-primary-rgb), 0.065);
    color: var(--im-color-primary);
    font-size: 18px;
    line-height: 1;

    i {
      line-height: 1;
    }
  }

  &__title {
    max-width: 260px;
    font-size: 12px;
    font-weight: 600;
    line-height: 1.35;
    color: var(--im-text-color);
  }

  &__hint {
    max-width: 300px;
    font-size: 12px;
    line-height: 1.5;
    color: var(--im-text-color-light);
  }

  &--compact {
    gap: 6px;
    padding: 14px 12px;

    .empty-state-view__icon {
      width: 34px;
      height: 34px;
      flex-basis: 34px;
      border-radius: 9px;
      font-size: 15px;
    }
  }
}
</style>
